/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { QuantumWave, QuantumWaveInterface } from "../QuantumWave";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "prod1",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "denominator",
        type: "uint256",
      },
    ],
    name: "FixedPointMathMulDivOverflow",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCChipAlreadyClaimed",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCExtendStopped",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCInvalidArrayLength",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCInvalidInputArguments",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCLengthNotEqualToTierLevelCount",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCValuesIsNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCWaveNotActive",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCWaveNotFinished",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCWrongChipOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCWrongEQNAmount",
    type: "error",
  },
  {
    inputs: [],
    name: "QWCWrongQENAmount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chipLevel",
        type: "uint256",
      },
    ],
    name: "AddChipFromQueueToMachine",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "date",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "chipLevel",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "capacity",
        type: "uint256",
      },
    ],
    name: "AddChipInQueue",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "machineId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chipIndex",
        type: "uint256",
      },
    ],
    name: "AddToMachine",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "nowNumberBigBlock",
        type: "uint256",
      },
    ],
    name: "BigBlockMove",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "machineId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "chipIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "extendShare",
        type: "uint256",
      },
    ],
    name: "ChipExtended",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "machineId",
        type: "uint256",
      },
    ],
    name: "MachineComplete",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardOre",
        type: "uint256",
      },
    ],
    name: "QuantumWaveStart",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "machineIds",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "chipIndexes",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "missedRewardAmount",
        type: "uint256",
      },
    ],
    name: "RewardOreClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "nowNumberSmallBlock",
        type: "uint256",
      },
    ],
    name: "SmallBlockMove",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "filledAmount",
        type: "uint256",
      },
    ],
    name: "WaveFilled",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "chipLevel",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "chipIds",
        type: "uint256[]",
      },
    ],
    name: "addChip",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bigBlockSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "machineIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "chipIndexes",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "fillAmount",
        type: "uint256",
      },
    ],
    name: "calculateProfitForFill",
    outputs: [
      {
        internalType: "uint256",
        name: "approximateReward",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "chipQueue",
    outputs: [
      {
        internalType: "uint128",
        name: "userId",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "startShare",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "chipQueueIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "machineIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "chipIndexes",
        type: "uint256[]",
      },
    ],
    name: "claimRewardOre",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "eqnAmountToExtendOneShare",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "machineIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "chipIndexes",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "totalExtendAmount",
        type: "uint256",
      },
    ],
    name: "extendChipBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "machineIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "chipIndexes",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "fillAmount",
        type: "uint256",
      },
    ],
    name: "fillWave",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "machineId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "chipIndex",
        type: "uint256",
      },
    ],
    name: "getChipInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "userId",
            type: "uint128",
          },
          {
            internalType: "uint120",
            name: "extendedShares",
            type: "uint120",
          },
          {
            internalType: "bool",
            name: "isClaimed",
            type: "bool",
          },
        ],
        internalType: "struct ChipInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "machineId",
        type: "uint256",
      },
    ],
    name: "getLengthChipsInMachine",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "machineId",
        type: "uint256",
      },
    ],
    name: "getMachineInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "level",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "startShares",
            type: "uint128",
          },
          {
            components: [
              {
                internalType: "uint128",
                name: "userId",
                type: "uint128",
              },
              {
                internalType: "uint120",
                name: "extendedShares",
                type: "uint120",
              },
              {
                internalType: "bool",
                name: "isClaimed",
                type: "bool",
              },
            ],
            internalType: "struct ChipInfo[]",
            name: "chips",
            type: "tuple[]",
          },
        ],
        internalType: "struct Machine",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "getTimestampEndPack",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "userId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "machineIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "chipIndexes",
        type: "uint256[]",
      },
    ],
    name: "getUserRewardOre",
    outputs: [
      {
        internalType: "uint256",
        name: "rewardOre",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "missedRewardOre",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "waveId",
        type: "uint256",
      },
    ],
    name: "getWaveInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint128",
            name: "startDate",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "rewardOre",
            type: "uint128",
          },
          {
            internalType: "uint256",
            name: "waveTotalShares",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "machineIds",
            type: "uint256[]",
          },
        ],
        internalType: "struct Wave",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRegistryContract",
        name: "_registry",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "machineIdForLevel",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "machines",
    outputs: [
      {
        internalType: "uint128",
        name: "level",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "startShares",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "meanSmallBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "needChipsForMachines",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "needMachines",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextMachineId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextWaveId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextWaveRewardOre",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nowNumberBigBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nowNumberSmallBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "qenAmountToFill",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quantumWaveFund",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "quantumWaves",
    outputs: [
      {
        internalType: "uint128",
        name: "startDate",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "rewardOre",
        type: "uint128",
      },
      {
        internalType: "uint256",
        name: "waveTotalShares",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "contract IRegistryContract",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_needChipsForMachines",
        type: "uint256[]",
      },
    ],
    name: "setNeedChipsForMachines",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_needMachines",
        type: "uint256",
      },
    ],
    name: "setNeedMachines",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_quantumWaveFund",
        type: "address",
      },
    ],
    name: "setQuantumWaveFund",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_waveActivePeriod",
        type: "uint256",
      },
    ],
    name: "setWaveActivePeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "userLastChipInQueue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "userWaveFilledAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "userWaveParticipationTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "waveActivePeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "waveIdForMachine",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type QuantumWaveConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: QuantumWaveConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class QuantumWave__factory extends ContractFactory {
  constructor(...args: QuantumWaveConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<QuantumWave> {
    return super.deploy(overrides || {}) as Promise<QuantumWave>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): QuantumWave {
    return super.attach(address) as QuantumWave;
  }
  override connect(signer: Signer): QuantumWave__factory {
    return super.connect(signer) as QuantumWave__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): QuantumWaveInterface {
    return new utils.Interface(_abi) as QuantumWaveInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): QuantumWave {
    return new Contract(address, _abi, signerOrProvider) as QuantumWave;
  }
}
